import React, { useEffect, useState } from "react";
import { P } from "../Texts";
import { DarkFormFieldStyle, DarkFormSelect, FormFieldHolder } from "./input.styles";

export const DarkSelectInput = React.forwardRef(
  (
    {
      className,
      children,
      containerClass,
      defaultValue,
      icon,
      iconClick,
      iconBefore,
      iconBeforeClass,
      iconBeforeClick,
      id,
      inputClassName,
      label,
      name,
      required,
      placeholder,
      type,
      marginBottom,
    },
    ref,
  ) => {
    const [_default, setDefault] = useState(null);

    useEffect(() => {
      setDefault(defaultValue);
    }, [defaultValue]);

    return (
      <FormFieldHolder
        marginBottom={marginBottom}
        className={`${containerClass ? containerClass : ""}`}
      >
        {label && (
          <label htmlFor={id}>
            <P fontSize="14px" fontFamily="semi" color="#47495C" className="mb-2">
              {label}
              {required && (
                <span
                  className=""
                  style={{
                    color: "#E62250",
                  }}
                >
                  *
                </span>
              )}
            </P>
          </label>
        )}

        <DarkFormFieldStyle className={className} key={`${name}-${_default}`}>
          {iconBefore && (
            <div
              className="h-full flex-shrink-0 py-2 px-4"
              onClick={iconBeforeClick}
            >
              <img src={iconBefore} alt="" className={iconBeforeClass} />
            </div>
          )}

          <DarkFormSelect
            type={type}
            ref={ref}
            id={id}
            name={name}
            defaultValue={_default}
            className={`flex-grow px-4 ${inputClassName}`}
            placeholder={placeholder}
          >
            {children}
          </DarkFormSelect>
          {icon && (
            <div
              className="h-full flex-shrink-0 py-2 px-4 cursor-pointer"
              onClick={iconClick}
            >
              <img src={icon} alt="" />
            </div>
          )}
        </DarkFormFieldStyle>
      </FormFieldHolder>
    );
  },
);
